import React from "react";

interface IProps {
  value: number;
  className?: string;
  fontSize?: number;
  color?: string;
  height?: number;
  width?: number;
}

const RiskFactorScoring = (props: IProps) => {
  const {
    value = 55,
    className,
    fontSize = 12,
    color = "#EB454D",
    height = 33,
    width = 45
  } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 30"
      fill="none"
      style={{ color, fontSize }}
    >
      <path
        d="M18.5049 2.6123C19.3047 1.46666 21.0022 1.47313 21.793 2.625L37.749 25.8682C38.6601 27.1953 37.7103 29 36.1006 29H3.91797C2.30124 29 1.3523 27.1812 2.27734 25.8555L18.5049 2.6123Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <text
        x="20"
        y="25"
        textAnchor="middle"
        fontSize="1em"
        fontWeight="bold"
        fill="currentColor"
      >
        {value}
      </text>
    </svg>
  );
};

export default React.memo(RiskFactorScoring);
